import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Icon20 } from 'builder/components/Icon'
import Media from 'builder/styles/media'

export const ButtonContainer = styled.div`
  ${Media.Phone`
    display: flex;
    flex-direction: column;
  `}
`

export const CrownIcon = styled(Icon20.Crown)`
  color: ${Colors.White};
  height: 24px;
  width: 24px;
`
